export default __webpack_public_path__ + "static/careers-benefits-block2-icon01.url-a0fe9b75099e498a93b35e55e6a72d80.svg";